import React from 'react';
import { Navbar, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../servicios/store';
import Alerta from '../componentes/Alerta';
import logo from '../data/inicio/logo.png';
import './BarraNavegacion.css';

const BarraNavegacion = ({ onShowLogin }) => {
  const location = useLocation();
  const { currentUser, logout } = useAuth();
  const isHomePage = location.pathname === '/inicio';

  const manejarLogout = async () => {
    try {
      await logout();
    } catch (error) {
      Alerta({
        type: 'error',
        title: 'Error',
        content: 'No se pudo cerrar sesión correctamente'
      });
    }
  };

  return (
    <Navbar expand="lg" className="custom-navbar">
      <div className="container-fluid">
        <Navbar.Brand as={Link} to="/inicio" className="brand">
          <img
            src={logo}
            alt="Logo Academia Pixel"
            className="brand-logo"
          />
          <span>Academia Pixel</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />

        <Navbar.Collapse id="basic-navbar-nav">
          <div className="ms-auto">
            {isHomePage && !currentUser ? (
              <Button
                onClick={onShowLogin}
                className="custom-access-btn"
                aria-label="Acceso estudiantes"
              >
                Acceso <span className="arrow">→</span>
              </Button>
            ) : currentUser && (
              <Button
                onClick={manejarLogout}
                className="custom-logout-btn"
                aria-label="Cerrar sesión"
              >
                Cerrar Sesión
              </Button>
            )}
          </div>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default BarraNavegacion;